
define('ldsh!common/templates/datepicker', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<form>\n  <div class="ed-form-group">\n    ';
 if (showLabel) { ;
__p += '\n    <label data-i18n="landingPage.datepicker.title"></label>\n    ';
 } ;
__p += '\n    <input\n      type="text"\n      results=""\n      name="from_date"\n      data-value="' +
((__t = ( from )) == null ? '' : __t) +
'"\n      placeholder=""\n      class="ed-form-control ed-date-item js-from-date e100"\n    >\n    <span class="ed-error-txt js-from-date-error"></span>\n  </div>\n  <div class="ed-form-group">\n    <input\n      type="text"\n      results=""\n      name="to_date"\n      data-value="' +
((__t = ( to )) == null ? '' : __t) +
'"\n      placeholder=""\n      class="ed-form-control ed-date-item js-to-date e100"\n    >\n    <span class="ed-error-txt js-to-date-error"></span>\n  </div>\n  ';
 if (showButton) { ;
__p += '\n  <button class="ed-btn ed-filter-btn ed-btn-sec">\n    <span class="txt">' +
((__t = ( buttonText )) == null ? '' : __t) +
'</span>\n  </button>\n  ';
 } ;
__p += '\n</form>\n';

}
return __p
};});

